/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock, WithPrivilegedToken } from '@gh/core-data';

export const CloneUsingPriceBookType = createEnum('SALES_CLONE_USING_PB_TYPE', {
  Allow: 'ALLOW',
  AllowWarning: 'ALLOW_WARNING',
  AllowNot: 'ALLOW_NOT',
});

export type CloneUsingPriceBookType = EnumSet<typeof CloneUsingPriceBookType>;

export type SystemVarsSalesDto = WithOptimisticLock<WithPrivilegedToken<{
  id: ID;
  officeId: number;
  nextQuoteNumber: number;
  canSelectPdf: boolean;
  rfqClone: CloneUsingPriceBookType;
  quickQuotesAllowed: boolean;
  rfqAdjustmentPct: number;
  rfqValidDays: number;
  rfqParagraph1: string;
  rfqParagraph2: string;
  useSalesEstimates: boolean;
  salesPersonCanSeeSalesEstimates: boolean;
  contactLetterPromptPrint: boolean;
}>>;
